var _jsxFileName = "/src/main/react/src/main/app/components/common/EntityInfo.js";
import React, { Component } from 'react';
import { Paper, Typography, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
const styles = () => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  }
});
class EntityInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      merlinId: props.merlinId != null ? props.merlinId : '',
      title: props.title != null ? props.title : '',
      subtitle: props.subtitle,
      adiId: props.adiId != null ? props.adiId : '',
      type: props.type != null ? props.type : ''
    };
  }
  render() {
    const classes = this.props.classes;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.centeredContainer,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      style: {
        marginTop: '1vh',
        width: '100%'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 32,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      wrap: "nowrap",
      alignContent: "stretch",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 33,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: "center",
      justify: "center",
      direction: "column",
      alignItems: "flex-start",
      md: 2,
      style: {
        paddingLeft: '5vh',
        paddingTop: '1vh',
        paddingBottom: '1vh'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 33
      }
    }, "MerlinID:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 38,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 33
      }
    }, "MediaGUID:")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 41,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 33
      }
    }, "Title:")), this.state.subtitle != null && this.state.type != null && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 37
      }
    }, this.state.type === "Episode" ? "Episode Title:" : this.state.type === "SportingEvent" ? "Subtitle:" : null)), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 49,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h5",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 33
      }
    }, "Type:"))), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      container: true,
      alignContent: "center",
      justify: "center",
      direction: "column",
      alignItems: "flex-start",
      md: 10,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 25
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 33
      }
    }, this.state.merlinId ? this.state.merlinId : 'n/a')), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        width: '80%',
        maxWidth: '80%'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      noWrap: true,
      variant: "h6",
      style: {
        /*overflow: 'scroll',*/textOverflow: 'ellipses'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 33
      }
    }, this.state.adiId ? this.state.adiId : 'n/a')), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 33
      }
    }, this.state.title ? this.state.title : 'n/a')), this.state.subtitle != null && this.state.type != null && /*#__PURE__*/React.createElement(Grid, {
      item: true,
      style: {
        width: '80%',
        maxWidth: '80%'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 64,
        columnNumber: 33
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      noWrap: true,
      variant: "h6",
      style: {
        /*overflow: 'scroll',*/textOverflow: 'ellipses'
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 37
      }
    }, this.state.subtitle ? this.state.subtitle : 'n/a')), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 68,
        columnNumber: 29
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 69,
        columnNumber: 33
      }
    }, this.state.type ? this.state.type : 'n/a'))))));
  }
}
export default withStyles(styles)(EntityInfo);